// extracted by mini-css-extract-plugin
export default {"linkModal":"linkModal__acoEp","linkModalContent":"linkModalContent__JRgHv","buttonBlack":"buttonBlack__x9Kk8","buttonWhite":"buttonWhite__qfHJN"};